import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import { Declarant } from './../../overrides/model/Declarant.js';
import { ReportStatus } from './../../overrides/model/ReportStatus.js';
import type { Constructor } from '@whispli/types';

export class __ReportSimple extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly name!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use anonymousFirstName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private anonymous_first_name!: string;

  @Expose({groups: ['client']})
  public get anonymousFirstName() {
    return this.anonymous_first_name
  }

  public set anonymousFirstName(value) {
    this.anonymous_first_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use anonymousLastName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private anonymous_last_name!: string;

  @Expose({groups: ['client']})
  public get anonymousLastName() {
    return this.anonymous_last_name
  }

  public set anonymousLastName(value) {
    this.anonymous_last_name = value
  }

  @Type(() => Declarant)
  @Expose({ groups: ['client', 'server'] })
  public readonly declarant!: Declarant | null;
  /**
   * @deprecated For backwards-compatibility only. Use isLocked
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private is_locked!: boolean | null;

  @Expose({groups: ['client']})
  public get isLocked() {
    return this.is_locked
  }

  public set isLocked(value) {
    this.is_locked = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly locale!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use syntheticStatus
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private synthetic_status!: string | null;

  @Expose({groups: ['client']})
  public get syntheticStatus() {
    return this.synthetic_status
  }

  public set syntheticStatus(value) {
    this.synthetic_status = value
  }

  @Type(() => ReportStatus)
  @Expose({ groups: ['client', 'server'] })
  public readonly status!: ReportStatus | null;
  /**
   * @deprecated For backwards-compatibility only. Use versionInternalName
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private version_internal_name!: string | null;

  @Expose({groups: ['client']})
  public get versionInternalName() {
    return this.version_internal_name
  }

  public set versionInternalName(value) {
    this.version_internal_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use versionInformantName
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private version_informant_name!: string | null;

  @Expose({groups: ['client']})
  public get versionInformantName() {
    return this.version_informant_name
  }

  public set versionInformantName(value) {
    this.version_informant_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use versionNote
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private version_note!: string | null;

  @Expose({groups: ['client']})
  public get versionNote() {
    return this.version_note
  }

  public set versionNote(value) {
    this.version_note = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use reportLabel
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private whisper_label!: string | null;

  @Expose({groups: ['client']})
  public get reportLabel() {
    return this.whisper_label
  }

  public set reportLabel(value) {
    this.whisper_label = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly source!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_at!: string | null;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private updated_at!: string | null;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }
}
export type ReportSimple = Omit<__ReportSimple, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'anonymous_first_name' | 'anonymous_last_name' | 'is_locked' | 'synthetic_status' | 'version_internal_name' | 'version_informant_name' | 'version_note' | 'whisper_label' | 'created_at' | 'updated_at'>
export const ReportSimple = __ReportSimple as any as Constructor<ReportSimple>
